import React from 'react';
import PropTypes from 'prop-types';

import './DreamCompaniesCard.scss';
import CompanyTypeahead from '../../Input/CompanyTypeahead/CompanyTypeahead';
import { ValidateForm } from '../../Includes/FormValidation';
import { buildSchemaShape } from '../../Includes/FormSchema/UserProfileSchema';
import axios from 'axios';
import Tag from '../../Elements/Tag/Tag';
import ErrorLabel from '../../Elements/ErrorLabel/ErrorLabel';
import ToolTip from '../../Wrappers/Tooltip/Tooltip';
import InfoIcon from '../../Groups/InfoIcon/InfoIcon';

export default class DreamCompaniesCard extends React.PureComponent {
    constructor(props) {
        super(props);

        this.state = {
            desiredCompanies: props.desiredCompanies || [],
            errordesiredCompanies: '',
            errorgeneral: '',
        };
    }

    static propTypes = {
        desiredCompanies: PropTypes.arrayOf(
            PropTypes.shape({
                companyId: PropTypes.number,
                companyName: PropTypes.string,
                id: PropTypes.number,
                logo: PropTypes.shape({
                    src: PropTypes.string,
                    alt: PropTypes.string,
                }),
                option: PropTypes.string,
                name: PropTypes.string,
            })
        ),
    };

    static defaultProps = {};

    handleSelected = async (selected) => {
        const desiredCompanies = selected.map((company) => ({
            id: company.id,
            name: company.name,
        }));
        const formValues = {
            desiredCompanies,
        };

        this.handleSubmit(formValues);
    };

    handleSubmit = async (formValues) => {
        const desiredCompaniesSchema = buildSchemaShape(formValues);

        const isValid = await ValidateForm(
            formValues,
            desiredCompaniesSchema,
            this.setStateWithObject
        );

        if (!isValid) {
            return;
        }

        try {
            await axios.patch('/api/user/profile', formValues);
            this.setStateWithObject({
                ...formValues,
                errordesiredCompanies: '',
                errorgeneral: '',
            });
        } catch (e) {
            const errorObject = {
                errorgeneral: 'An unexpected error has occured',
            };
            this.setStateWithObject(errorObject);
        }
    };

    setStateWithObject = (stateObject) => {
        this.setState(stateObject);
    };

    renderTooltip = () => {
        return (
            <ToolTip
                tooltipText={
                    'FGB will only use this information to find new company partners and it will not be visible to anyone.'
                }
                multiLine={true}
                className="field-label-tooltip"
            >
                <InfoIcon />
            </ToolTip>
        );
    };

    render() {
        return (
            <div className="component-Users-DreamCompaniesCard">
                <div className="header-section">
                    <h6 className="section-header">
                        Who are your dream companies? (Choose up to 5)
                    </h6>
                    {this.renderTooltip()}
                </div>
                <CompanyTypeahead
                    placeholder={'Type an employer name or add a new one'}
                    isMulti={true}
                    items={this.state.desiredCompanies}
                    onUpdate={this.handleSelected}
                    withTags={true}
                />

                {!!(
                    this.state.errordesiredCompanies.length > 0 ||
                    this.state.errorgeneral.length > 0
                ) && (
                    <ErrorLabel
                        error={
                            this.state.errordesiredCompanies ||
                            this.state.errorgeneral
                        }
                    />
                )}
            </div>
        );
    }
}
